<script setup lang="ts" generic="T extends SelectableValue">
import type { Selectable, SelectableValue } from '@/components/selectBox/selectBox';

import { useSchoolsSearch } from '@/hooks/search/useSchoolsSearch';

import FormComboboxInput, {
  FormComboboxProps
} from '@/components/formComboboxInput/FormComboboxInput.vue';

type Props = Omit<FormComboboxProps<number>, 'options'> & {
  programIds?: number[];
};

const props = defineProps<Props>();

defineEmits<{
  'update:modelValue': [Selectable<number> | null];
}>();

const { schoolOptions, isLoading, onQueryChange, updateSearchFilters } = useSchoolsSearch(
  props.searchFilters
);

watch(
  () => props.programIds,
  (programIds) => {
    updateSearchFilters({ program_ids: programIds });
  }
);
</script>

<template>
  <FormComboboxInput
    v-bind="$props"
    :isLoading="isLoading"
    :options="schoolOptions"
    :onFilter="onQueryChange"
    :modelValue="modelValue as Selectable<number>"
    @update:modelValue="(value) => $emit('update:modelValue', value as Selectable<number>)"
    @open="() => onQueryChange('')"
  />
</template>
